import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { ClusterData } from '../types';

import { getClusterById } from 'RestAPIs/admin';

import { showSnackbar } from 'components/shared';

export const useGetClusterRowData = (rowId) => {
  const { t } = useTranslation('common');

  return useQuery({
    enabled: !!rowId,
    queryKey: ['clusters', 'get', rowId],
    queryFn: async () => {
      const { data } = await getClusterById(rowId);
      return data as ClusterData;
    },
    onError: () => {
      showSnackbar({
        severity: 'error',
        message: t('errorDuringFetching')
      });
    }
  });
};
